export default __webpack_public_path__ + "static/media/opportunities.6c733229.svg";